<template>
  <!-- <div class="app flex-row align-items-center"> -->
  <!-- <div class="container"> -->
  <b-row class="justify-content-center">
    <b-col md="8">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form @submit.prevent="login">
              <h1>Login</h1>
              <p class="text-muted">Sign In to your account</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-user"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  v-model="username"
                  type="text"
                  class="form-control"
                  placeholder="Email Address"
                  autocomplete
                />
              </b-input-group>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  autocomplete="off"
                />
              </b-input-group>
              <b-row>
                <b-col cols="6">
                  <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                  <span style="color:red;" v-if="isFailedLogin"
                    >Invalid Email/Password</span
                  >
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-button
                    :disabled="EmptyTextBoxes"
                    class="mr-0 mt-2"
                    type="submit"
                    size="md"
                    variant="primary"
                  >
                    <i class="fa fa-key"></i>
                    Log In
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
        <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
          <b-card-body class="text-center">
            <div>
              <h2>Sign up</h2>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              <b-button variant="primary" class="active mt-3">Register Now!</b-button>
            </div>
          </b-card-body>
        </b-card>-->
      </b-card-group>
    </b-col>
  </b-row>
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      isFailedLogin: false
    };
  },
  computed: {
    EmptyTextBoxes() {
      return this.username == "" || this.password == "";
    }
  },
  methods: {
    login() {
      this.$store
        .dispatch("n_user/authenticate", {
          username: this.username,
          password: this.password
        })
        .then(this.checkAccess);
    },
    checkAccess() {
      if (this.$store.state.n_user.n_current_user_has_access) {
        this.$router.push({
          path: "Campaigns"
        });
      } else {
        this.isFailedLogin = true;
      }
    }
  }
};
</script>
